import React from 'react';
import './UnifiedButton.css';

interface UnifiedButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'small' | 'medium' | 'large';
  icon?: React.ReactNode;
  className?: string;
  title?: string;
}

const UnifiedButton: React.FC<UnifiedButtonProps> = ({
  children,
  onClick,
  disabled = false,
  variant = 'secondary',
  size = 'medium',
  icon,
  className = '',
  title,
}) => {
  const buttonClass = [
    'unified-btn',
    `unified-btn-${variant}`,
    `unified-btn-${size}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
      title={title}
    >
      {icon && (
        <div className="unified-btn-icon">
          {icon}
        </div>
      )}
      <span className="unified-btn-text">{children}</span>
    </button>
  );
};

export default UnifiedButton;